/* eslint-disable */
export default {
  DirectNumber: '直撥',
  MainCompanyNumber: '主要',
  CompanyNumber: '公司',
  CompanyFaxNumber: '傳真',
  Blocked: '已封鎖',
  AdditionalCompanyNumber: '公司',
  ForwardedCompanyNumber: '已轉接',
  from: '來自',
} as const;

// @key: @#@"DirectNumber"@#@ @source: @#@"Direct"@#@
// @key: @#@"MainCompanyNumber"@#@ @source: @#@"Main"@#@
// @key: @#@"CompanyNumber"@#@ @source: @#@"Company"@#@
// @key: @#@"CompanyFaxNumber"@#@ @source: @#@"Fax"@#@
// @key: @#@"Blocked"@#@ @source: @#@"Blocked"@#@
// @key: @#@"AdditionalCompanyNumber"@#@ @source: @#@"Company"@#@
// @key: @#@"ForwardedCompanyNumber"@#@ @source: @#@"Forwarded"@#@
// @key: @#@"from"@#@ @source: @#@"From"@#@
